import React, { Component } from 'react';
import { connect } from 'react-redux';

import { generateQuery } from '../../../../utils/miscUtils';
import * as BoardAction from '../../../../library/board/BoardAction';

import Paging from '../../../common/components/Paging';

import { values } from '../config';
import SearchBox from './SearchBox';
import Item from './Item';
import { QuestionContent } from './List.styled';
import { routes } from '../../../../constants/routes';
import { getQueryObjFromRouter } from '../../../../utils/miscUtils';

const mapStateToProps = (state, ownProps) => {
    return {
        postList: state.BoardReducer.postList,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        initPostDetail: () => {
            dispatch(BoardAction.initPostDetail());
        },
        getPostList: (boardType, boardName, pageNo, pageSize, query) => {
            return dispatch(
                BoardAction.getPostList(
                    boardType,
                    boardName,
                    pageNo,
                    pageSize,
                    query
                )
            );
        },
    };
};

class List extends Component {
    constructor(props) {
        super(props);

        this.onClickListItem = this.onClickListItem.bind(this);
        this.onClickPageChange = this.onClickPageChange.bind(this);
        this.onClickQna = this.onClickQna.bind(this);

        this.state = {
            openedPostId: 0,
        };
    }

    componentDidMount() {
        this.getList();
    }

    componentDidUpdate(prevProps, prevState) {
        const { history } = this.props;

        if (
            history.query.top_tag !== prevProps.history.query.top_tag ||
            history.query.pageno !== prevProps.history.query.pageno ||
            history.query.search !== prevProps.history.query.search
        ) {
            this.getList();
        }
    }

    componentWillUnmount() {
        this.props.initPostDetail();
    }

    getList() {
        const { history } = this.props;
        const params = { ...history.query, ...getQueryObjFromRouter(history) };

        if (params.top_tag === '전체') {
            delete params.top_tag;
        }

        return this.props.getPostList(
            values.BOARD_TYPE,
            values.BOARD_NAME,
            params.pageno,
            values.PAGE_SIZE,
            params
        );
    }

    onClickListItem(id) {
        const { openedPostId } = this.state;
        if (id !== openedPostId) {
            this.setState({ openedPostId: id });
        }
    }

    onClickQna(event) {
        event.preventDefault();
        this.props.history.push(routes.customer.report);
    }

    onClickPageChange(pageNo) {
        const { history } = this.props;
        const query = {
            search: history.query.search ? history.query.search : null,
            top_tag: history.query.top_tag ? history.query.top_tag : null,
            pageno: pageNo,
        };
        if (history.query.is_noticed) {
            this.props.history.push(
                `${routes.customer.question}${generateQuery({
                    ...query,
                    is_noticed: true,
                })}`
            );
        } else {
            this.props.history.push(
                `${routes.customer.question}${generateQuery({ ...query })}`
            );
        }
    }

    renderList() {
        const { postList, history } = this.props;
        const { openedPostId } = this.state;

        if (!postList.results.length) {
            return this.renderEmpty();
        }

        return postList.results.map((postInfo, idx) => (
            <Item
                key={idx}
                index={idx}
                history={history}
                post={postInfo}
                openedPostId={openedPostId}
                onClickListItem={this.onClickListItem}
            />
        ));
    }

    renderEmpty() {
        const { history } = this.props;

        if (!history.query.search) {
            return (
                <div className="message-box no-data">
                    <p>
                        <strong>등록된 게시물이 없습니다.</strong>
                    </p>
                </div>
            );
        }

        return (
            <div className="message-box no-data faq">
                <p>
                    <strong>
                        <b>{history.query.search}</b>에 대한 검색 결과가
                        없습니다.
                    </strong>
                </p>
            </div>
        );
    }

    render() {
        const { postList, history } = this.props;
        const { pageno = 1 } = history.query;
        return (
            <QuestionContent id="contents" className="question-list">
                <h4>자주하는 질문</h4>
                <SearchBox history={history} />
                <ul className="list-type accordion">{this.renderList()}</ul>
                <Paging
                    selected={parseInt(pageno, 10)}
                    step={5}
                    onClick={this.onClickPageChange}
                    count={postList.count ? postList.count : 1}
                    pageSize={values.PAGE_SIZE}
                />
                <div className="footer-info-box button-on-right">
                    <strong>찾고자 하는 정보가 없으신가요?</strong>
                    <p>
                        직접 질문해보세요.
                        <br />
                        빠른 시간 내에 답변을 드립니다.
                    </p>
                    <a
                        href="#"
                        className="btn-type2 qna on"
                        onClick={this.onClickQna}
                    >
                        신고 · 건의 · 문의
                    </a>
                </div>
            </QuestionContent>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(List);
